<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css" />

<div class="container" fxLayout="column">
  <div fxLayout="row" class="device-container">
    <div fxLayout="row wrap" class="user-search-container" fxLayoutGap="10">
      <mat-form-field appearance="outline" class="mat-form-field">
        <mat-select placeholder={{getUserOptionLabel(filter)}} [(ngModel)]="filter" (selectionChange)="onFilterChange()">
          <mat-option *ngFor="let option of getFilteredUserOptions()" [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
  
      <div class="search-bar" fxLayout="row" fxLayoutAlign="start center">
        <input type="text" [(ngModel)]="searchText" placeholder="Search" appEnterKey (enterKey)="onSearchClick()" trim>
        <span class="search-icon" (click)="onSearchClick()"><i class="fas fa-search"></i></span>
      </div>
    </div>
  </div>
</div>
<app-user-detail [searchQuery]="searchText"></app-user-detail>

<div *ngIf="dataFetched && userDetailComponent.rowData && userDetailComponent.rowData.length === 0" class="no-data-message">
  No Record Found
</div>
